import {
  cwsiCategories,
  mbsiCategories,
  ncciCategories,
  osiCategories,
  ndtiCategories,
  ndmiCategories,
  ndreCategories,
  ndviCategories,
  tvdiCategories,
} from '../constants/indices-color.constants';

export function getIndicesColor(value: number, product?: string): string {
  let categories;

  switch (product) {
    case 'CWSI':
      categories = cwsiCategories;
      break;
    case 'MBSI':
      categories = mbsiCategories;
      break;
    case 'NCCI':
      categories = ncciCategories;
      break;
    case 'OSI':
      categories = osiCategories;
      break;
    case 'NDRE':
      categories = ndreCategories;
      break;
    case 'NDVI':
      categories = ndviCategories;
      break;
    case 'NDMI':
      categories = ndmiCategories;
      break;
    case 'NDTI':
      categories = ndtiCategories;
      break;
    case 'TVDI':
      categories = tvdiCategories;
      break;
    default:
      break;
  }

  const category = categories?.find(cat => cat.value === value);
  return category ? category.color : '#ffffff';
}
